<template>
	<div>
		<v-navigation-drawer
			v-model="drawer"
			fixed
			temporary
			right
		>
			<template>
				<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline;">
					<div class="title__section">Tutoriales</div>
					<v-btn icon @click="drawer = false" class="ma-2">
						<v-icon small>close</v-icon>
					</v-btn>
				</div>
			</template>

			<v-divider></v-divider> 
			
			<v-list nav dense v-for="video in videosSolicitante" :key="video.title" class="transparent pa-2">
					<v-flex class="pa-3">
						<v-list-item-title class="rc-listItem-title">{{ video.title }}</v-list-item-title>
						<div class="description__video ">
							{{ video.descripcion }}
						</div>
						<div @click="getVideoDetails(video.src, video.image)" class="video__img" style="position: relative; cursor: pointer;">
							<v-img class="" :src="video.image" fit height="120px" style="border-radius: 10px;" /> 
							<v-btn icon flat @click="getVideoDetails(video.src, video.image)" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: auto; border-radius: 10px;">
								<v-icon name="">play_circle_filled</v-icon>
							</v-btn>
						</div>
					</v-flex>
					<v-divider></v-divider>
			</v-list>
		</v-navigation-drawer>
		<v-dialog v-if="modalVideo" v-model="modalVideo" width="70vw" >
			<v-card style="min-width: 650px; border-radius: 25px; height: auto; overflow-y: hidden;">
				<Videos :urlVideo="urlVideo" :posterVideo="posterVideo" />
			</v-card>
		</v-dialog>
	</div> 
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
    import Videos from "@/components/media/Videos.vue";
	import { mapState } from "vuex";
	
	@Component({
		components: {
			Videos,
		},
		props: {
			// datos
			openMenu: Boolean,

        },
		computed: {
			...mapState(["showMenuTutorial"]),
			
		},
		watch:{
			"$store.state.showMenuTutorial":{
				handler(){
					this.$data.drawer = this.$props.openMenu;
				},
			},
			"drawer":{
				handler(){
					this.$store.commit('showMenuTutorial', this.$data.drawer);
				},
			}
		},
		data() { // Data Menu
			return {
				drawer: false,
				videosSolicitante: [
					{
						title: 'Recorrido por la plataforma',
						descripcion: 'Conoce las funcionalidades que tiene la plataforma IRIS',
						src: '/media/videos/Plataforma_IRIS_para_emisores.mp4',
						image: '/media/videos/img_video_1.png'
					},
					{
						title: 'Habilitar autenticación en dos pasos.',
						descripcion: 'Mejora la seguridad de tu cuenta habilitando la autenticación en dos pasos',
						src: '/media/videos/mfa.mp4',
						image: '/media/videos/mfa.png'
					},
				],
				modalVideo: false,
				urlVideo: null,
				posterVideo:null,
			}
		},
		methods: {
			getVideoDetails(url, image){
				this.$data.urlVideo = url;
				this.$data.posterVideo = image;
				this.$data.modalVideo = true;
			}
		}
		
	})
	export default class TutorialSidebar extends Vue {}
</script>

<style lang="scss" scoped>

	.no-ctive::v-deep a{
		opacity: 0.5;
	}
	.rc-menuPanelBtn{
		cursor: pointer; 
		color: $rc-prim-n1;
	}

	.title__section{
		font-size: 24px;
		color: #3d3d3d;
		padding: 1rem;
		font-weight: 600;
	}

	.rc-listItem-title{
		font-weight: 600;
		font-size: 14px;
	}

	.v-list{
		padding: 5px 0px !important;
	}
	
	.rc-listItem-pad{
		padding: 5px 5px;
	}
	.rc-text-color-alert{
		color: #E83F29;
	}
	
	/* Menu */
	.rc-list_ico{
		height: 20px;
		width: 20px;
	}
	.rc-right-bar{
		height: calc(100vh - 64px);
		background-color: $rc-escala5;
	}

	.rc-noml{
		margin-left: 0 !important;
	}

	.rc-menuDrawer{
		margin-top:64px !important;
		z-index:1; 
		width:150px !important; 
		height: calc( 100vh - 64px ) !important; 
		min-height: calc( 100vh - 64px ) !important; 
	}

	

	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				
			}@else if $breakpoint == "large"{
				
			}@else if $breakpoint == "medium-to-large"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small-to-medium"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important; 
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}
		}
	}
	@media (min-width:1264px) {

    .custom-margin{
      margin-left: 5px;
	}
  }
  @media (max-width:1264px) {

    .custom-margin{
      margin-left: 0px;
    }
  }

  .video__img:hover {
	border-radius: 25px;
    opacity:0.8; 
	// filter: alpha(opacity=100);
}
</style>
